/**
 * Example "ABZ020 (Arbeitsanweisung)" or
 * "EDD010 (Erfahrungsbericht (technisch))"
 */
const TERM_WITH_DESCRIPTION = /^(\S+?) \(/i;

export function normalizeTermName(termName: string): string {
  if (!TERM_WITH_DESCRIPTION.test(termName)) return termName;
  const name = termName.match(TERM_WITH_DESCRIPTION)?.[1];
  if (!name) throw new Error();
  return name;
}
